import { render, staticRenderFns } from "./tipovariante.vue?vue&type=template&id=4dcc1365&scoped=true&"
import script from "./tipovariante.vue?vue&type=script&lang=js&"
export * from "./tipovariante.vue?vue&type=script&lang=js&"
import style0 from "./tipovariante.vue?vue&type=style&index=0&id=4dcc1365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc1365",
  null
  
)

export default component.exports